import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { createBaseSelector, registerSlice } from "shared/lib/redux";
import { RailSearchCardModel } from "./model";

type RailSearchCard = RailSearchCardModel[];

const initialAppState: RailSearchCard = [];

const railSearchCardSlice = createSlice({
  name: "railSearchCards",
  initialState: initialAppState,
  reducers: {
    prependSearchCardAction: (
      state,
      { payload: { data, unique = true } }: PayloadAction<{ data: RailSearchCardModel; unique?: boolean }>
    ) => {
      if (unique) {
        const foundCard = state.find((card) => card.reference === data.reference);
        if (foundCard) return;
      }
      state.unshift(data);
    },
    removeSearchCardAction: (state, action: PayloadAction<RailSearchCardModel>) => {
      return state.filter((card) => card.reference !== action.payload.reference);
    },
    updateSearchCardAction: (state, action: PayloadAction<RailSearchCardModel>) => {
      const targetCard = state.findIndex((card) => card.reference === action.payload.reference);
      if (targetCard !== -1) {
        state[targetCard] = action.payload;
      }
    },
  },
});

const railSearchCardBaseSelector = createBaseSelector(railSearchCardSlice);

registerSlice([railSearchCardSlice]);

export const railSearchCardStore = {
  actions: railSearchCardSlice.actions,
  selectors: {
    searchCards: createSelector(railSearchCardBaseSelector, (s) => s),
  },
};
